import { clientAddressConstant, status } from "../_constants";

let initialState = {}

export function client(state = initialState, action) {
    switch (action.type) {
        case clientAddressConstant.CREATE_CLIENT_ADDRESS_REQUEST:
            return {
                ...state,
                client_status: status.IN_PROGRESS,
                client_data: null
            }
        case clientAddressConstant.CREATE_CLIENT_ADDRESS_SUCCESS:
            return {
                ...state,
                client_status: status.SUCCESS,
                client_data: action.data
            }
        case clientAddressConstant.CREATE_CLIENT_ADDRESS_FAILURE:
            return {
                ...state,
                client_status: status.FAILURE,
                client_data: action.data
            }
        default:
            return state;
    }
}